// src/utils/cards/cardConstants.js

export const CARD_SCHEMA_VERSION = 2;

export const PARTNER_WALL_CARD_SCHEMA_VERSION = 3;

export const CARD_GENERATION_SCHEMA_VERSION = 1;

export const CARD_LEAD_SCHEMA_VERSION = 1;

export const CARD_STATUS = {
  DRAFT: "draft",
  PUBLISHED: "published",
  HIDDEN: "hidden",
};

export const CARD_VISIBILITY = {
  PRIVATE: "private",
  PUBLIC: "public",
  PARTNER_WALL: "partner_wall",
  SHARED_LINK: "shared_link",
};

export const CARD_MODERATION_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
};

export const CARD_CONTENT_TYPE = {
  QUESTION: "question",
};

export const CARD_CATEGORY = {
  CAREGIVING: "caregiving",
};

export const CARD_INTENT = {
  COMFORT: "comfort",
};

export const CARD_RECIPIENT_TYPE = {
  PARENT: "parent",
};

export const CARD_ORIGIN = {
  PARTNER_WALL: "partner_wall",
};

export const CARD_CREATION_METHOD = {
  REFINE: "refine",
  SEEDED: "seeded",
  MANUAL: "manual",
};

export const DEFAULT_PARTNER_ID = "mcaad";

export const DEFAULT_WALL_ID = "mcaad-caregiving-popup";

export const DEFAULT_WALL_PATH = `/wall/${DEFAULT_WALL_ID}`;

export const DEFAULT_PUBLIC_WALL = {
  id: DEFAULT_WALL_ID,
  title: "A Living Wall of Care",
  eyebrow: "LettuceTalk at MCAAD",
  partnerId: DEFAULT_PARTNER_ID,
  slug: "mcaad",
  status: "active",
  visibility: "public",
};

export const DEFAULT_THEME_ID = "lettucetalk-classic-yellow";

export const LANGUAGE_CODES = {
  English: "en",
  Spanish: "es",
  "Simplified Chinese": "zh",
  Tagalog: "tl",
  Vietnamese: "vi",
  Arabic: "ar",
  French: "fr",
  Korean: "ko",
  Russian: "ru",
  Portuguese: "pt",
  "Haitian Creole": "ht",
  Hindi: "hi",
  Persian: "fa",
  Icelandic: "is",
  Japanese: "ja",
};

export const DEFAULT_TAGS = [
  "mcaad",
  "caregiving",
  "support",
  "family",
  "empathy-ai",
];
